'use client';

import { ArticleType } from '@stadionhq-v3/base-ui';
import { generateCardIcon } from '@utils/icons';
import { generateFullPathname } from '@utils/paths/generateFullPathname.utils';
import templateConfig from '@templateConfig';
import articleCardTransform, {
  ArticleCardSettings,
} from '@utils/transforms/components/molecules/articleCard.transform';
import ArticleCard from '@components/v3/molecules/article-card';
import { ArticleRendererProps } from './articleCardRenderer.types';

const ArticleCardRenderer = ({
  article,
  locale,
  dictionary,
  publishDateFormat,
  size,
}: ArticleRendererProps) => {
  const settings: ArticleCardSettings = {
    dictionary,
    publishDateFormat,
  };

  return (
    <ArticleCard
      {...articleCardTransform(article, locale, settings)}
      size={size}
      cardIcon={generateCardIcon(article.format as ArticleType)}
      slug={generateFullPathname({
        locale,
        route: templateConfig.navigation.routes.ARTICLE,
        params: { article: article.slug },
      })}
    />
  );
};

export default ArticleCardRenderer;
